import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 16px;
  gap: 2px;
  cursor: pointer;

  background: ${(props) => props.theme.colors.outline};
  border-radius: 12px;

  font-size: 13px;

  .title {
    color: ${(props) => props.theme.colors.inactive};
  }

  .main-container {
    display: flex;
    justify-content: space-between;

    .driver-details {
      display: flex;
      flex-direction: column;
      width: calc(100% - 120px);

      .driver-description {
        display: inline-flex;
        align-items: center;
        padding: 8px 0;
        margin-bottom: 16px;
        gap: 8px;

        .avatar {
          img {
            width: 40px;
            height: 40px;
            border-radius: 100px;
            object-fit: cover;
          }
        }

        .driver-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            mim-width: 80px;
            color: ${(props) => props.theme.colors.text};
          }
        }
      }
    }

    .horizontal-line {
      height: 0;
      border: 1px solid ${(props) => props.theme.colors.inactive};
    }

    .tags-container {
      display: flex;
      align-items: center;
      margin-top: 32px;
      text-transform: uppercase;

      .truck-tag {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .alert-tag {
        display: flex;
        align-items: center;
        padding-left: 18px;
        gap: 4px;
        min-width: 65px;
        background: ${(props) => props.theme.colors.outline};

        .icon {
          color: ${(props) => props.theme.colors.main_cta};
        }
      }
    }

    .score-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      font-weight: 700;
      font-size: 35px;

      width: 100px;
      height: 100px;
      background: ${(props) => props.theme.colors.main_cta};
      box-shadow: ${(props) => props.theme.shadows.glow};
      border-radius: 50%;
      color: ${(props) => props.theme.colors.black};

      &.red {
        background: ${(props) => props.theme.colors.red};
        box-shadow: none;
      }

      &.no-score {
        background: ${(props) => props.theme.colors.inactive};
        box-shadow: none;
        font-size: 20px;
        opacity: 0.5;
      }
    }
  }
`;

export default { Wrapper };
